module.exports = __webpack_public_path__ + "static/media/getting_started.830b10ff.svg";